
// Google Ads Configuration
export const GOOGLE_ADS_CONFIG = {
  CONVERSION_ID: 'AW-17359318680',
  CONVERSIONS: {
    FORM_SUBMITTED: 'JcD1CLPj5vcaEJjdyNVA', // Lead completa o formulário
    WHATSAPP_CLICK: 'u3j3CNr-ttEcEJjdyNVA'  // Website-native conversion (Contact) - Enhanced Conversions habilitado
  },
  // Conversion values (in BRL)
  VALUES: {
    FORM_SUBMITTED: 100,
    WHATSAPP_CLICK: 50
  }
};

// Instructions for setting up conversions in Google Ads
export const CONVERSION_SETUP_INSTRUCTIONS = `
Próximos passos para configurar as conversões no Google Ads:

1. Acesse o Google Ads Console
2. Vá para Ferramentas e Configurações > Conversões
3. Clique em "+" para criar uma nova conversão
4. Crie as seguintes conversões:

CONVERSÃO 1: Formulário Enviado (Principal)
- Nome: "Formulário Enviado TaxHealth"
- Categoria: Lead
- Valor: 100 BRL
- Contagem: Uma por clique
- Janela de conversão: 30 dias
- Incluir em "Conversões": Sim

CONVERSÃO 2: Click WhatsApp (Secundária)
- Nome: "Click WhatsApp TaxHealth"
- Categoria: Lead
- Valor: 50 BRL
- Contagem: Uma por clique
- Janela de conversão: 7 dias
- Incluir em "Conversões": Sim

Após criar as conversões, copie os labels (ex: "AbCdEfGhIj") e substitua no arquivo config.ts
`;

export default GOOGLE_ADS_CONFIG;
